import { mountClassic } from '../render/classic/classic-app.js';
import { acesupClassicSpec } from '../variants/acesup/classic-spec.js';

const root = document.getElementById('classic-stage');
if (!root) throw new Error('missing #classic-stage');
mountClassic(acesupClassicSpec, { root, title: 'Aces Up' });
